module.exports = __webpack_public_path__ + "static/media/grocery-product-1.d395b63d.png";